function retryDelay(error: any, attempt: number): number | undefined {
    const status = error?.response?.status;
    const transient = [408, 429, 500, 502, 503, 504].includes(status) ||
        (!status && ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'ECONNRESET'].includes(error?.code));
    if (!transient) return;
    const retryAfter = error?.response?.headers?.['retry-after'];
    if (retryAfter !== undefined) {
        const seconds = Number(retryAfter);
        const delay = Number.isFinite(seconds) ? seconds * 1000 : Date.parse(retryAfter) - Date.now();
        // A longer server cooldown is left to a later manual retry; never retry before it.
        if (delay > 30000) return;
        if (Number.isFinite(delay)) return Math.max(0, delay);
    }
    return 500 * 2 ** attempt + Math.random() * 250;
}

export default async function retryRequest<T>(request: () => Promise<T>, signal: AbortSignal): Promise<T> {
    for (let attempt = 0; ; attempt++) {
        if (signal.aborted) throw new DOMException('Upload cancelled', 'AbortError');
        try { return await request(); } catch (error) {
            const delay = retryDelay(error, attempt);
            if (signal.aborted || attempt >= 2 || delay === undefined) throw error;
            await new Promise<void>((resolve, reject) => {
                const abort = () => { clearTimeout(timer); reject(new DOMException('Upload cancelled', 'AbortError')); };
                const timer = setTimeout(() => { signal.removeEventListener('abort', abort); resolve(); }, delay);
                signal.addEventListener('abort', abort, { once: true });
                if (signal.aborted) { signal.removeEventListener('abort', abort); abort(); }
            });
        }
    }
}
